// Generated by purs version 0.15.0
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_Promotions_FirstOrderDiscount_RPC_Types from "../Restaumatic.Promotions.FirstOrderDiscount.RPC.Types/index.js";
import * as Restaumatic_Site_RPC from "../Restaumatic.Site.RPC/index.js";
var fodBackend = {
    claimFOD: /* #__PURE__ */ Restaumatic_Site_RPC.sitesRPC(/* #__PURE__ */ Network_JsonRPC.encodeRequest(Restaumatic_Promotions_FirstOrderDiscount_RPC_Types.encodeClaimFODRequest)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_FirstOrderDiscount_RPC_Types.encodeClaimFODRequest)))(/* #__PURE__ */ Network_JsonRPC.decodeResponse(Restaumatic_Promotions_FirstOrderDiscount_RPC_Types.decodeClaimFODResponse))(Restaumatic_Promotions_FirstOrderDiscount_RPC_Types.rpcMethodNameClaimFODRequest)
};
export {
    fodBackend
};
//# sourceMappingURL=index.js.map
